import { useCallback, useMemo } from 'react';
import { debounce, SuggestionsStore } from 'sdk';
import { ConversationsStore } from 'sdk';

export const useOnChange = (
	suggestionsStore: SuggestionsStore,
	onChangeProp: (v: string) => void,
	useSuggestions: boolean,
	convStore: ConversationsStore,
	timer: { v: number }
): ((v: string) => void) => {
	const debounced = useMemo(
		() => debounce(suggestionsStore.getSuggestion, 200, suggestionsStore),
		[suggestionsStore]
	);

	const onTyping = useCallback(() => {
		if (!convStore.isLatestConversationResolved && !timer.v) {
			convStore.sendTyping();
			timer.v = window.setTimeout(() => (timer.v = 0), 5 * 1000);
		}
	}, [convStore, timer]);

	const onChange = useCallback(
		(text: string) => {
			onChangeProp(text);
			useSuggestions && debounced(text);
			onTyping();
		},
		[onChangeProp, debounced, useSuggestions, onTyping]
	);

	return onChange;
};
